/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingText_storyTellingTab = {
    readonly tabTitle: string;
    readonly contentHeader: string;
    readonly contentCreatorAttribution: {
        readonly creatorName: string;
        readonly creatorBrowseUrl: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null;
    readonly relatedCreators: ReadonlyArray<{
        readonly __typename: string;
    } | null> | null;
    readonly supplementaryEditorial: {
        readonly totalResults: number | null;
    } | null;
    readonly contentBodyText: string;
    readonly articleLink: string | null;
    readonly browseLink: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly smallImage: string | null;
    readonly tabType: string;
    readonly " $refType": "PdpRespStorytellingText_storyTellingTab";
};
export type PdpRespStorytellingText_storyTellingTab$data = PdpRespStorytellingText_storyTellingTab;
export type PdpRespStorytellingText_storyTellingTab$key = {
    readonly " $data"?: PdpRespStorytellingText_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingText_storyTellingTab">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "FragmentSpread",
    "name": "SeoLink_linkData",
    "args": null
  }
];
return {
  "kind": "Fragment",
  "name": "PdpRespStorytellingText_storyTellingTab",
  "type": "StoryTellingTab",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabTitle",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentHeader",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "contentCreatorAttribution",
      "storageKey": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "creatorName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "creatorBrowseUrl",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": (v0/*: any*/)
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relatedCreators",
      "storageKey": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "supplementaryEditorial",
      "storageKey": null,
      "args": null,
      "concreteType": "WordpressArticlesType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "contentBodyText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "articleLink",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "browseLink",
      "storageKey": null,
      "args": null,
      "concreteType": "LinkData",
      "plural": false,
      "selections": (v0/*: any*/)
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tabType",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
(node as any).hash = '13cb8f1aa430b18cb9077992fdc43026';
export default node;
